module.exports = __webpack_public_path__ + "static/media/vettingScheduledV2.3067c91f.svg";